<template>
    <section class="d-flex flex-column h-full" :dir="dir">
        <header class="mdc-top-app-bar position-static">
            <div class="mdc-top-app-bar__row">
                <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                    <a class="material-icons mdc-top-app-bar__navigation-icon">close</a>
                </section>
                
                <section class="mdc-top-app-bar__section title">
                    <div class="mdc-top-app-bar__title">
                        Sample
                    </div>                
                </section>

                <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                    <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search">search</a>
                </section>
            </div>
        </header>
        <div class="flex-grow-1 scroll-y pda-default">
            
            <div class="d-flex flex-row justify-content-around t-subtitle1">
                <div class="flex-grow-1 pda-10 t-center" :class="dir === 'ltr' ? 'bg-paymentBlue' : ''" @click="changeDirection('ltr')" @keypress="changeDirection('ltr')" tabindex="0">ltr</div>
                <div class="flex-grow-1 pda-10 t-center" :class="dir === 'rtl' ? 'bg-paymentBlue' : ''" @click="changeDirection('rtl')" @keypress="changeDirection('rtl')" tabindex="0">rtl</div>
            </div>
            <div class="mgt-16">
                <div class="t-headline10">Padding/Margin</div>
                <div class="mdc-card mdc-elevation--z2 pda-default mgt-16">
                    <div class="t-body1 bg-paymentBlue pda-default">pda-default</div>
                    <div class="t-body1 bg-paymentBlue mgt-16 pdt-8 pdb-8 pdl-8 pdr-8">mgt-16 pdt-8 pdb-8 pdl-8 pdr-8</div>
                    <div class="t-body1 bg-paymentBlue mgt-8 mgb-8 mgl-8 mgr-8">mgt-8 mgb-8 mgl-8 mgr-8</div>
                    
                </div>
            </div>

            <div class="mgt-16">
                <div class="t-headline10">Font Size</div>
                <div class="mdc-card mdc-elevation--z2 pda-default mgt-16">
                    <div class="t-headline1">.t-headline1 </div>
                    <div class="t-headline2">.t-headline2 </div>
                    <div class="t-headline3">.t-headline3 </div>
                    <div class="t-headline4">.t-headline4 </div>
                    <div class="t-headline5">.t-headline5 </div>
                    <div class="t-headline6">.t-headline6 </div>
                    <div class="t-headline7">.t-headline7 </div>
                    <div class="t-headline8">.t-headline8 </div>
                    <div class="t-headline9">.t-headline9 </div>
                    <div class="t-headline10">.t-headline10</div>
                    <div class="t-headline11">.t-headline11</div>
                    <div class="t-headline12">.t-headline12</div>
                    <div class="t-headline13">.t-headline13</div>
                    <div class="t-headline14">.t-headline14</div>
                    <div class="t-subtitle1">.t-subtitle1 </div>
                    <div class="t-subtitle2">.t-subtitle2 </div>
                    <div class="t-subtitle3">.t-subtitle3 </div>
                    <div class="t-subtitle4">.t-subtitle4 </div>
                    <div class="t-subtitle5">.t-subtitle5 </div>
                    <div class="t-subtitle6">.t-subtitle6 </div>
                    <div class="t-body1">.t-body1</div>
                    <div class="t-body2">.t-body2</div>
                    <div class="t-body3">.t-body3</div>
                    <div class="t-body4">.t-body4</div>
                    <div class="t-body5">.t-body5</div>
                    <div class="t-body6">.t-body6</div>
                    <div class="t-body7">.t-body7</div>
                    <div class="t-body8">.t-body8</div>
                    <div class="t-helper">.t-helper</div>
                    <div class="t-caption">.t-caption</div>
                </div>
            </div>

            <div class="mgt-16">
                <div class="t-headline10">Font Color</div>
                <div class="mdc-card mdc-elevation--z2 pda-default mgt-16">
                    <div class="t-body1 t-color-headlineBlack ">t-color-headlineBlack </div>
                    <div class="t-body1 t-color-bodyGrayA">t-color-bodyGrayA</div>
                    <div class="t-body1 t-color-signGray">t-color-signGray</div>
                    <div class="t-body1 t-color-signBlue">t-color-signBlue</div>
                    <div class="t-body1 t-color-textfieldActive">t-color-textfieldActive</div>             
                    <div class="t-body1 t-color-quizGray">t-color-quizGray</div>
                    <div class="t-body1 t-color-signGray">t-color-signGray</div>             
                    <div class="t-body1 t-color-bodyGrayB">t-color-bodyGrayB</div>
                    <div class="t-body1 t-color-gray3">t-color-gray3</div>
                    <div class="t-body1 t-color-gray4">t-color-gray4</div>
                    <div class="t-body1 t-color-gray5">t-color-gray5</div>
                    <div class="t-body1 t-color-gray6">t-color-gray6</div>
                    <div class="t-body1 t-color-disableBtn">t-color-disableBtn</div>
                    <div class="t-body1 t-color-quizBlueGray">t-color-quizBlueGray</div>
                    <div class="t-body1 t-color-mainBtn">t-color-mainBtn</div>
                    <div class="t-body1 t-color-signGray">t-color-signGray</div>
                    <div class="t-body1 t-color-white ">t-color-white </div>
                    <div class="t-body1 t-color-yellow">t-color-yellow</div>
                </div>
            </div>

            <div class="mgt-16">
                <div class="t-headline10">Font Color</div>
                <div class="mdc-card mdc-elevation--z2 pda-default mgt-16">
                    <div class="t-body1 t-color-headlineBlack ">t-color-headlineBlack </div>
                    <div class="t-body1 t-color-bodyGrayA">t-color-bodyGrayA</div>
                    <div class="t-body1 t-color-signGray">t-color-signGray</div>
                    <div class="t-body1 t-color-signBlue">t-color-signBlue</div>
                    <div class="t-body1 t-color-textfieldActive">t-color-textfieldActive</div>             
                    <div class="t-body1 t-color-quizGray">t-color-quizGray</div>
                    <div class="t-body1 t-color-signGray">t-color-signGray</div>             
                    <div class="t-body1 t-color-bodyGrayB">t-color-bodyGrayB</div>
                    <div class="t-body1 t-color-gray3">t-color-gray3</div>
                    <div class="t-body1 t-color-gray4">t-color-gray4</div>
                    <div class="t-body1 t-color-gray5">t-color-gray5</div>
                    <div class="t-body1 t-color-gray6">t-color-gray6</div>
                    <div class="t-body1 t-color-disableBtn">t-color-disableBtn</div>
                    <div class="t-body1 t-color-quizBlueGray">t-color-quizBlueGray</div>
                    <div class="t-body1 t-color-mainBtn">t-color-mainBtn</div>
                    <div class="t-body1 t-color-signGray">t-color-signGray</div>
                    <div class="t-body1 t-color-white ">t-color-white </div>
                    <div class="t-body1 t-color-yellow">t-color-yellow</div>
                </div>
            </div>

            <div class="mgt-16">
                <div class="t-headline10">Font Align</div>
                <div class="mdc-card mdc-elevation--z2 pda-default mgt-16">
                    <div class="t-body1 t-left">align left</div>
                    <div class="t-body1 t-center">align center</div>
                    <div class="t-body1 t-right">align right</div>
                </div>
            </div>

            <div class="mgt-16">
                <div class="t-headline10">Font Align</div>
                <div class="mdc-card mdc-elevation--z2 pda-default mgt-16">
                    <div class="t-body1 t-left">align left</div>
                    <div class="t-body1 t-center">align center</div>
                    <div class="t-body1 t-right">align right</div>
                </div>
            </div>

            <div class="mgt-16">
                <div class="t-headline10">Text Overflow</div>
                <div class="mdc-card mdc-elevation--z2 pda-default mgt-16">
                    <div class="t-body1 t-line-1">한 줄 말줄임입니다.한 줄 말줄임입니다.한 줄 말줄임입니다.</div>
                    <hr class="divider mgt-8">
                    <div class="t-body1 t-line-2 mgt-8">두줄 말줄임입니다.두줄 말줄임입니다.두줄 말줄임입니다.두줄 말줄임입니다.두줄 말줄임입니다.</div>                    
                </div>
            </div>

            <div class="mgt-16">
                <div class="t-headline10">Text Line Through</div>
                <div class="mdc-card mdc-elevation--z2 pda-default mgt-16">
                    <div class="t-line-through-red">빨간색 가운데 줄</div>
                    <hr class="divider mgt-8">
                    <div class="t-line-through-gray">회색 가운데 줄</div>
                </div>
            </div>

            <div class="mgt-16">
                <div class="t-headline10">Element Size</div>
                <div class="mdc-card mdc-elevation--z2 pda-default mgt-16 d-flex flex-row justify-content-around">
                    <div class="t-helper t-center bg-paymentBlue w-100 h-100">100 * 100</div>
                    <div class="t-helper t-center bg-paymentBlue w-50 h-50">50 * 50</div>
                </div>
            </div>

            <div class="mgt-16">
                <div class="t-headline10">Background Color</div>
                <div class="mdc-card mdc-elevation--z2 pda-default mgt-16 bg-paymentBlue">
                    <div class="bg-white">bg-white</div>
                    <div class="bg-paymentBlue">bg-paymentBlue</div>
                    <div class="bg-documentGray">bg-documentGray</div>
                </div>
            </div>

            <div class="mgt-16">
                <div class="t-headline9">Grid</div>
                <div class="d-grid mgt-16">
                    <div class="mdc-card mdc-elevation--z3 grid-row-1">
                        <div class="pda-default text-center">
                            <div class="t-headline9">
                                1
                            </div>
                            <div class="t-body3 t-color-bodyGrayA mgt-21">
                                Text1
                            </div>

                        </div>
                    </div>

                    <div class="mdc-card mdc-elevation--z3 grid-row-1">
                        <div class="pda-default text-center">
                            <div class="t-headline9">
                                2
                            </div>
                            <div class="t-body3 t-color-bodyGrayA mgt-21">
                                Text2
                            </div>

                        </div>
                    </div>

                    <div class="mdc-card mdc-elevation--z3 grid-row-1">
                        <div class="pda-default text-center">
                            
                            <div class="t-body3 t-color-bodyGrayA mgt-21">
                                Text3
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <div class="mgt-16">
                <div class="t-headline10">Scroll</div>
                <div class="mdc-card mdc-elevation--z2 pda-default mgt-16">
                    <div class="h-100 scroll-y bg-paymentBlue">
                        scroll-y-1<br>
                        scroll-y-2<br>
                        scroll-y-3<br>
                        scroll-y-4<br>
                        scroll-y-5<br>
                        scroll-y-6<br>
                        scroll-y-7<br>
                        scroll-y-8<br>
                        scroll-y-9<br>
                    </div>
                </div>
            </div>

            <div class="mgt-16">
                <div class="t-headline10">Card Sample1</div>
                <div class="mdc-card mdc-elevation--z3 pdb-16 mgt-16">
                    <div class="t-subtitle2 mgt-16 mgl-16 mgr-16">
                        Title
                    </div>
                    <div class="mgt-30">
                        <div class="d-flex flex-row align-content-center pdt-16 mgl-8 mgr-8">
                            <div class="pdl-8 pdr-8">
                                <img src="@/assets/progress_icon.svg" class="w-24 h-24">
                            </div>
                            <div class="pdl-8 pdr-8 flex-grow-1 align-self-center">
                                Text1-1
                            </div>
                            <div class="pdl-8 pdr-8 align-self-center">
                                Text1-2
                            </div>
                        </div>
                    </div>

                    <div class="mgt-30">
                        <div class="d-flex flex-row align-content-center pdt-16 mgl-8 mgr-8">
                            <div class="pdl-8 pdr-8">
                                <img src="@/assets/progress_icon.svg" class="w-24 h-24">
                            </div>
                            <div class="pdl-8 pdr-8 flex-grow-1 align-self-center">
                                Text2-1
                            </div>
                            <div class="pdl-8 pdr-8 align-self-center">
                                Text2-2
                            </div>
                        </div>
                    </div>

                    <div class="mgt-30">
                        <div class="d-flex flex-row align-content-center pdt-16 mgl-8 mgr-8">
                            <div class="pdl-8 pdr-8">
                                <img src="@/assets/progress_icon.svg" class="w-24 h-24">
                            </div>
                            <div class="pdl-8 pdr-8 flex-grow-1 align-self-center">
                                Text3-1
                            </div>
                            <div class="pdl-8 pdr-8 align-self-center">
                                Text3-2
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            

            <div class="mgt-16">
                <div class="t-headline10">Card Sample2</div>
                <div class="mdc-card mdc-elevation--z3 mgt-16">
                    <div class="t-subtitle2 mgt-16 mgb-16 mgl-16 mgr-16">
                        Title
                    </div>
                
                    <div>
                        <div class="pdb-16">
                            <div class="d-flex flex-row justify-content-between pdt-12 mgl-8 mgr-8">
                                <div class="pdl-8 pdr-8">
                                    <img src="@/assets/mission_icon.svg" alt="">
                                </div>
                                <div class="pdl-8 pdr-8 flex-grow-1">
                                    <div class="t-body1">
                                        Text1-1
                                    </div>                                    
                                </div>
                            </div>

                            <div class="d-flex flex-row-reverse mgr-16 mgl-16">
                                Text1-2
                                
                            </div>
                        </div>


                        <div class="d-flex flex-row">
                            <div class="mgl-16 mgr-16 w-40"></div>
                            <div class="flex-grow-1">
                                <hr class="divider">
                            </div>
                        </div>                        
                    </div>
                    <div>
                        <div class="pdb-16">
                            <div class="d-flex flex-row justify-content-between pdt-12 mgl-8 mgr-8">
                                <div class="pdl-8 pdr-8">
                                    <img src="@/assets/mission_icon.svg" alt="">
                                </div>
                                <div class="pdl-8 pdr-8 flex-grow-1">
                                    <div class="t-body1">
                                        Text1-1
                                    </div>                                    
                                </div>
                            </div>

                            <div class="d-flex flex-row-reverse mgr-16 mgl-16">
                                Text1-2
                                
                            </div>
                        </div>


                        <div class="d-flex flex-row">
                            <div class="mgl-16 mgr-16 w-40"></div>
                            <div class="flex-grow-1">
                                <hr class="divider">
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>


            











            




            

            

            
            

        </div>
    </section>
</template>

<script>
export default {
    name: 'Sample',
    
    
    data() {
        return {
            dir: 'ltr'
        }
    },    

    mounted() {
        
    },

    updated() {
        
        
    },
    methods: {
        changeDirection(mode) {
            this.dir = mode
        }
    }

    
}
</script>

<style lang="scss">

</style>
